<template>
  <router-link
    v-if="showImproveQuestion"
    :to="improveQuestionRoute"
    class="improve-question-container"
  >
    <icon
      name="info"
      variant="516173"
    />
    <span>Improve this question</span>
  </router-link>
</template>

<script>
import Icon from '@components/singletons/icon';

export default {
  components: { Icon },
  props: {
    question: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    improveQuestionRoute() {
      let message = '';
      if (this.question.id) {
        message = `Improve this question: Question ID ${this.question.id}\nEnter your suggestions after this line:\n`;
      }
      return { name: 'support', query: {message: message}};
    },
    showImproveQuestion() {
      const pv = this.$store.getters['productVars/get']['disable_improve_question'];
      const disabled = pv && pv.value === 'true';
      return !disabled;
    },
  },
};
</script>
<style lang='scss' scoped>
.improve-question-container {
  align-items: center;
  background-image: linear-gradient(to top, #f2f4f7, #ffffff);
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  box-sizing: border-box;
  color: #354052;
  display: flex;
  font-weight: $semi-bold;
  height: rem-calc(30);
  padding: rem-calc(6);

  span {
    font-size: rem-calc(14);
    margin-left: rem-calc(8);

    @include breakpoint(small) {
      font-size: rem-calc(10);
    }
  }

  img {
    height: rem-calc(16);
    width: rem-calc(16);

    @include breakpoint(small) {
      height: rem-calc(12);
      width: rem-calc(12);
    }
  }
}
</style>
